export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string[];
  tags: string[];
  rating: number;
  status: 'completed' | 'ongoing';
  description: string;
  chapters: number;
  views: number;
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '秘密教学',
    author: 'Kidari Studio',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20featuring%20a%20young%20couple%20in%20a%20romantic%20embrace%2C%20soft%20warm%20lighting%2C%20delicate%20watercolor%20art%20style%2C%20gentle%20pastel%20tones%2C%20emotional%20atmosphere%2C%20clean%20minimalist%20composition%2C%20Korean%20webtoon%20aesthetic&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: ['korean', 'romance', 'ongoing'],
    tags: ['恋爱', '校园', '甜蜜'],
    rating: 9.5,
    status: 'ongoing',
    description: '一位年轻帅气的家庭教师，和他美丽动人的学生之间展开的秘密而甜蜜的故事。当教学变成心动，当师生关系变得模糊，他们将如何面对这份禁忌之恋？细腻的情感刻画与精美的画风，让这部作品成为韩漫恋爱题材的经典之作。',
    chapters: 128,
    views: 35800000,
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 2,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20of%20a%20beautiful%20girl%20with%20makeup%20transformation%2C%20before%20and%20after%20concept%2C%20soft%20romantic%20atmosphere%2C%20delicate%20illustration%20with%20warm%20peach%20and%20pink%20tones%2C%20Korean%20webtoon%20art%20style%2C%20elegant%20composition&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: ['korean', 'romance', 'drama'],
    tags: ['恋爱', '校园', '化妆', '变身'],
    rating: 9.7,
    status: 'completed',
    description: '外貌平凡的女孩通过化妆技巧华丽变身，成为校园女神。但完美的伪装之下，真实的她又该何去何从？当两个优秀的男生同时闯入她的生活，一个是知道她真面目的青梅竹马，一个是爱上她女神模样的校园男神，她会如何选择？',
    chapters: 236,
    views: 89200000,
    updatedAt: '2026-07-28',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    title: '剑尊归来',
    author: 'Redice Studio',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20cover%20featuring%20a%20powerful%20swordsman%20in%20martial%20arts%20pose%2C%20dramatic%20action%20scene%2C%20traditional%20oriental%20elements%2C%20vibrant%20energy%20effects%2C%20Korean%20webtoon%20style%2C%20epic%20fantasy%20atmosphere%2C%20cinematic%20composition&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: ['korean', 'action', 'fantasy', 'ongoing'],
    tags: ['武侠', '重生', '热血', '奇幻'],
    rating: 9.6,
    status: 'ongoing',
    description: '曾经的天下第一剑尊，在背叛中含恨而终。然而命运给了他第二次机会，让他重生回到少年时代。带着前世的记忆和绝世武功，他誓要改写命运，向所有背叛者复仇！华丽的剑术对决与紧凑的剧情让人欲罢不能。',
    chapters: 89,
    views: 45600000,
    updatedAt: '2026-08-05',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 4,
    title: '我独自升级',
    author: 'DUBU',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20with%20a%20lone%20hunter%20surrounded%20by%20shadow%20warriors%2C%20mysterious%20dungeon%20atmosphere%2C%20neon%20purple%20and%20dark%20blue%20energy%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20style%2C%20epic%20scale&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: ['korean', 'action', 'fantasy', 'completed'],
    tags: ['战斗', '升级', '奇幻', '热血'],
    rating: 9.8,
    status: 'completed',
    description: '在一个突然出现怪物的世界里，被称为"人类最弱兵器"的成振宇，在生死边缘获得了神秘系统的力量。从此他踏上了独自升级的征程，一步步从最弱成为最强。系统面板、暗影军团、惊天反转，这部作品重新定义了韩漫的巅峰水准。',
    chapters: 179,
    views: 125000000,
    updatedAt: '2026-06-15',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 5,
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20featuring%20a%20powerful%20sorcerer%20with%20dark%20energy%2C%20dynamic%20action%20pose%2C%20modern%20urban%20fantasy%20setting%2C%20bold%20linework%2C%20Japanese%20shonen%20manga%20aesthetic%2C%20dramatic%20composition&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: ['japanese', 'action', 'fantasy', 'ongoing'],
    tags: ['战斗', '咒术', '校园', '热血'],
    rating: 9.4,
    status: 'ongoing',
    description: '高中生虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此被卷入咒术师与诅咒的战斗世界。在东京都立咒术高等专门学校，他结识了伏黑惠、钉崎野蔷薇等伙伴，一同对抗强大的诅咒与咒灵。精彩的战斗场面与深邃的世界观让这部作品成为日漫新世代标杆。',
    chapters: 262,
    views: 98000000,
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 6,
    title: '邻家天使',
    author: '佐伯さん',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20Japanese%20manga%20cover%20of%20a%20beautiful%20angelic%20girl%20in%20school%20uniform%2C%20soft%20sunlight%20through%20windows%2C%20gentle%20romantic%20atmosphere%2C%20warm%20golden%20tones%2C%20Japanese%20slice%20of%20life%20art%20style%2C%20delicate%20illustration&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: ['japanese', 'romance', 'drama'],
    tags: ['恋爱', '校园', '日常', '治愈'],
    rating: 9.3,
    status: 'ongoing',
    description: '独居的高中生藤宫周，与住在隔壁的学校第一美少女椎名真昼，因为一把雨伞而拉近了距离。从邻居到朋友，从朋友到恋人，两个孤独的灵魂在日常相处中逐渐靠近。温柔的日常描写与甜蜜的互动，让人感受到恋爱最纯粹的美好。',
    chapters: 95,
    views: 28500000,
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 7,
    title: '全职猎人',
    author: '富坚义博',
    cover: 'https://readdy.ai/api/search-image?query=A%20classic%20Japanese%20manga%20cover%20featuring%20a%20young%20adventurer%20with%20a%20fishing%20rod%2C%20adventure%20fantasy%20theme%2C%20bold%20shonen%20art%20style%2C%20vibrant%20colors%2C%20Japanese%20manga%20aesthetic%2C%20dynamic%20composition%20with%20action%20lines&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: ['japanese', 'action', 'fantasy', 'ongoing'],
    tags: ['冒险', '战斗', '念能力', '经典'],
    rating: 9.6,
    status: 'ongoing',
    description: '少年小杰为了寻找父亲金，踏上了成为猎人的冒险之旅。在猎人考试中结识了奇犽、酷拉皮卡、雷欧力等伙伴，一同面对幻影旅团、嵌合蚁等强敌。念能力系统的精心设计、人物塑造的深度以及剧情的不确定性，让这部作品成为跨越时代的经典。',
    chapters: 400,
    views: 156000000,
    updatedAt: '2026-05-20',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 8,
    title: '社内恋爱',
    author: 'NARAK Studio',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20office%20manhwa%20cover%20with%20a%20handsome%20CEO%20and%20beautiful%20employee%20in%20professional%20attire%2C%20elegant%20office%20background%2C%20sophisticated%20warm%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20romantic%20tension&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: ['korean', 'romance', 'drama', 'ongoing'],
    tags: ['恋爱', '职场', '办公室', '甜蜜'],
    rating: 9.2,
    status: 'ongoing',
    description: '新入职的职场菜鸟林秀雅，意外发现公司那位冷面上司私下竟是她最喜欢的网络漫画作者！从此两人的关系在职场与漫画世界之间来回穿梭。办公室里的秘密恋情、职场中的成长蜕变，一部集甜蜜与励志于一身的浪漫职场故事。',
    chapters: 67,
    views: 18900000,
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 9,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20demon%20slayer%20manga%20cover%20featuring%20a%20young%20swordsman%20with%20water%20breathing%20effect%2C%20traditional%20Japanese%20aesthetic%2C%20vibrant%20action%20scene%2C%20bold%20art%20style%2C%20taisho%20era%20setting%2C%20dramatic%20composition&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: ['japanese', 'action', 'fantasy', 'completed'],
    tags: ['战斗', '鬼杀队', '兄妹', '热血'],
    rating: 9.7,
    status: 'completed',
    description: '大正时代的日本，少年灶门炭治郎一家被鬼残忍杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复成人类的方法，炭治郎加入鬼杀队，踏上了斩杀恶鬼的旅程。水之呼吸、日之呼吸的华丽剑技，兄妹之间感人至深的羁绊，让全球数亿读者为之动容。',
    chapters: 205,
    views: 210000000,
    updatedAt: '2026-03-10',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 10,
    title: '甜蜜暴击',
    author: '极光动漫',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20Korean%20romance%20manhwa%20cover%20with%20a%20blushing%20couple%20sharing%20a%20sweet%20moment%2C%20cherry%20blossom%20background%2C%20soft%20pink%20and%20warm%20peach%20tones%2C%20Korean%20webtoon%20aesthetic%2C%20dreamy%20atmosphere%2C%20romantic%20composition&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: ['korean', 'romance', 'ongoing'],
    tags: ['恋爱', '甜宠', '轻松', '校园'],
    rating: 9.1,
    status: 'ongoing',
    description: '元气满满的少女苏小糖，撞上了高冷傲娇的校草学长。本以为是一场灾难般的邂逅，没想到却开启了一段甜到齁的恋爱日常。没有狗血剧情，没有虐心桥段，只有满满的甜蜜暴击！轻松愉快的阅读体验，让你每一话都能露出姨母笑。',
    chapters: 56,
    views: 12300000,
    updatedAt: '2026-08-05',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 11,
    title: '电锯人',
    author: '藤本树',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20dark%20fantasy%20manga%20cover%20featuring%20a%20chainsaw%20devil%20hunter%2C%20urban%20horror%20setting%2C%20bold%20dramatic%20composition%2C%20dark%20red%20and%20black%20color%20scheme%2C%20Japanese%20shonen%20manga%20style%2C%20intense%20action%20atmosphere&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: ['japanese', 'action', 'fantasy', 'drama'],
    tags: ['战斗', '恶魔', '黑暗', '热血'],
    rating: 9.3,
    status: 'ongoing',
    description: '背负着父亲巨额债务的少年淀治，与恶魔啵奇塔融合后获得了变身电锯人的能力。加入公安对魔特异4课后，他开始了斩杀恶魔的生活。在这部疯狂又感人至深的作品中，藤本树用他独特的叙事风格，讲述了一个关于梦想、家庭与人性的另类故事。',
    chapters: 179,
    views: 67000000,
    updatedAt: '2026-07-30',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 12,
    title: '反派千金的逆袭',
    author: 'SLEE Studio',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20romance%20manhwa%20cover%20with%20an%20elegant%20noblewoman%20in%20a%20lavish%20gown%2C%20palace%20background%2C%20golden%20and%20rose%20color%20tones%2C%20Korean%20webtoon%20style%2C%20sophisticated%20aristocratic%20atmosphere%2C%20dramatic%20lighting&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: ['korean', 'fantasy', 'romance', 'drama'],
    tags: ['穿越', '贵族', '逆袭', '恋爱'],
    rating: 9.4,
    status: 'ongoing',
    description: '现代白领韩智雅一觉醒来，发现自己穿越成了小说中注定悲剧收场的反派千金。为了改变命运，她决定远离原著男女主，专心经营自己的事业。然而随着她的改变，原本的故事线也被彻底打乱——那些本该爱上女主的人，怎么都围着她转了？',
    chapters: 103,
    views: 31200000,
    updatedAt: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
];

export const chaptersList: Record<number, { num: number; title: string; date: string }[]> = {
  1: [
    { num: 1, title: '第1话 相遇', date: '2024-03-15' },
    { num: 2, title: '第2话 秘密', date: '2024-03-22' },
    { num: 3, title: '第3话 心跳', date: '2024-03-29' },
    { num: 125, title: '第125话 告白', date: '2026-07-20' },
    { num: 126, title: '第126话 答案', date: '2026-07-27' },
    { num: 127, title: '第127话 牵手', date: '2026-08-03' },
    { num: 128, title: '第128话 幸福', date: '2026-08-04' },
  ],
};

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.category.includes(slug));
}

export function getHotComics(): Comic[] {
  return comics.filter((c) => c.isHot);
}

export function getNewComics(): Comic[] {
  return comics.filter((c) => c.isNew);
}

export function getRecommendedComics(): Comic[] {
  return comics.filter((c) => c.isRecommended);
}

export function getLatestComics(): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
}